<template>
  <div :class="classes" class="wt-upload-file">
      <el-upload
      :style="{height:height?height+'px':'',width:width?width+'px':''}"
      :action="action"
      ref="upload"
      :headers="headers"
      :disabled="disabled"
      :with-credentials="true"
      :listType="listType"
      :limit="limit"
      :file-list="fileList"
      :before-upload="beforeAvatarUpload||beforeUpload"
      :show-file-list="showFileList"
      :multiple="multiple"
      :drag="drag"
      :accept="accept"
      :data="data"
      :on-success="onSuccess"
      :on-remove="onRemove"
      :on-error="onError"
      :auto-upload="autoUpload"
      :on-preview="handlePreview"
      :http-request="httpRequest"
      :class="{'wt-upload-file--no-add':(!multiple&&fileList.length!=0||!isAdd)}">
          <slot/>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible" size="tiny">
				<img width="100%" :src="dialogImageUrl" alt="">
			</el-dialog>
  </div>
</template>

<script>
// 组件class前缀
import { Upload } from 'element-ui'
import OssSectionUpload from '../../../utils/oss-sectioning'
const prefixCls = 'wt-upload-file'
export default {
  name: 'wt-upload-file',
  props: {
    httpRequest: {
      type: Function
    },
    resourceConfig: String,
    value: {
      type: [Array, Object, String],
      default: function () {
        return []
      }
    },
    action: {
      type: String,
      default: '/apartments/api/apartments/upload-image'
    },
    headers: {
      type: Object,
      default: function () {
        return {}
      }
    },
    multiple: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default: function () {
        return {}
      }
    },
    name: {
      type: String,
      default: 'file'
    },
    listType: {
      type: String,
      default: 'picture-card'
    },
    limit: {
      type: Number,
      default: 9
    },
    beforeAvatarUpload: {
      type: Function
    },
    showFileList: {
      type: Boolean,
      default: true
    },
    drag: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: ''
    },
    imgUrl: {
      type: String,
      default: ''
    },
    // 只上传一张图片时，是否显示上传图片（用于按钮上传，不显示上传图片）
    showFile: {
      type: Boolean,
      default: true
    },
    pictureStyle: {
      // oss图片样式
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    pathUrlName: {
      type: String,
      default: ''
    },
    height: {
      type: [Number, String],
      default: 0
    },
    width: {
      type: [Number, String],
      default: 0
    },
    //是否是浪潮云上传文件
    isLangchao:{
      type:Boolean,
      default:false
    },
    needName:{
      type:Boolean,
      default:false
    },
    //是否允许放大查看上传文件
    isReview:{
      type:Boolean,
      default:false
		},
		outReview:Boolean
  },
  components: {
    'el-upload': Upload
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    isShowName () {
      return this.listType === 'text'
    }
  },
  data () {
    return {
      isAdd: true,
      fileList: [], // 已上传的文件列表
      upload: this.$refs.upload,
      currentValue: this.value,
      progress: 0,
      dialogImageUrl:null,
      dialogVisible:false
    }
  },
  watch: {
    value: {
      handler: function (val, old) {
        if (val !== old) {
          this.currentValue = val
				}
				// 第一次初始化
				if (!this.multiple) {
					this.fileList=[]
					this.value&&(typeof this.value==='string'?this.fileList.push(this.build_file_list(this.value)):this.fileList=this.value)
				}else{
					this.fileList = this.build_file_list(this.value)
				}
      },
      immediate: true
    },
    currentValue: {
      handler (val, old) {
				if ((this.limit && val && val.length >= this.limit&&this.multiple)||(!this.multiple&&val)) {
          this.isAdd = false
        }
        if ((val && val.length < this.limit)||!val) {
          this.isAdd = true
        }
        if (val !== old) {
          this.$emit('input', this.currentValue)
				}
				if (!this.multiple) {
					this.fileList=[]
					val&&(Array.isArray(this.build_file_list(val))?this.fileList=this.build_file_list(val):this.fileList.push(this.build_file_list(val)))
				}else{
        	this.fileList = this.build_file_list(val)
				}
      },
      deep: true
    }
  },
  methods: {

    getChangeName () {
      let year = (new Date()).getFullYear()
      let month = (new Date()).getMonth() + 1
      month = month > 9 ? month : '0' + month
      let day = (new Date()).getDate()
      day = day > 9 ? day : '0' + day
      let hour = (new Date()).getHours()
      hour = hour > 9 ? hour : '0' + hour
      let min = (new Date()).getMinutes()
      min = min > 9 ? min : '0' + min
      let second = (new Date()).getSeconds()
      second = second > 9 ? second : '0' + second
      return '' + year + month + day + hour + min + second
    },
    dealUploadData (changeFileName, params, url) {
      let func = new OssSectionUpload(changeFileName, params.file, url)
      this.fileList.push({
        url: this.resourceConfig + '/' + this.objectId + '/' + changeFileName,
        name: changeFileName,
        client: func,
        status: 'uploading',
        percentage: 0,
        continueUpload: false
      })
      func.multipartUpload((p, fileName) => {
        this.fileList.forEach((ele, idx) => {
          if (fileName === ele.name) {
            if (parseFloat((p * 100)) >= 100) {
              this.fileList[idx].percentage = 100
            } else {
              this.fileList[idx].percentage = parseFloat((p * 100))
            }
          }
        })
        if (this.fileList.every(item => item.percentage === 100)) {
          this.isUpload = true
        }
      })
    },
    beforeUpload (file) {
      const splitArr = file.name.split('.')
      const lastName = splitArr[splitArr.length - 1]
      if (this.fileType === 'fastq') {
        const afterName = splitArr[splitArr.length - 1]
        const afterName2 = splitArr[splitArr.length - 2]
        let fastqName = ''
        if (afterName2 === 'fastq' || afterName2 === 'fq') {
          fastqName = afterName2 + '.' + afterName
        } else {
          fastqName = afterName
        }
        if (this.value.length >= 1) {
          let every = this.value.every(item => item.name !== file.name)
          if (!every) {
            this.$message.error('文件不能相同或者文件名不能相同！')
            return false
          }
        }
        if (fastqName === 'fq.gz' || fastqName === 'fastq.gz' || fastqName === 'fastq' || fastqName === 'fq') {
          return true
        } else {
          this.$message.error('请选择相对应的文件类型！')
          return false
        }
      } else if (this.fileType === 'VCF') {
        if (lastName === 'vcf') {
          return true
        } else {
          this.$message.error('请选择相对应的文件类型！')
          return false
        }
      } else if (this.fileType === 'BAM') {
        if (this.value.length >= 2) {
          if (this.value[0].name === file.name) {
            this.$message.error('两个文件不能相同或者文件名不能相同！')
            return false
          }
        }
        if (lastName === 'bam') {
          return true
        } else {
          this.$message.error('请选择相对应的文件类型！')
          return false
        }
      } else if (this.fileType === 'gz') {
        if (lastName === 'gz') {
          return true
        } else {
          this.$message.error('请选择相对应的文件类型！')
          return false
        }
      } else {
        return true
      }
    },
    handlePreview (file) {
			if(this.outReview){
				this.$emit('handlePreview',file)
				return
			}
      if(this.isReview){
      this.dialogImageUrl = file.url||file.response;
      this.dialogVisible = true;
      return
      }
      if (this.fileList.every(item => item.percentage === 100)) {
        this.$message.info('已全部上传完毕')
        return
      }
      this.fileList.forEach((ele, idx) => {
        if (ele.name === file.name) {
          if (ele.percentage === 100) {
            this.$message.info('已上传完毕')
            return
          }
          console.log('ele.client',ele.client)
          if (ele.continueUpload) {
            this.$message.info('恢复上传')
            ele.client.multipartUpload((p) => {
              if (parseFloat((p * 100)) >= 100) {
                this.fileList[idx].percentage = 100
              } else {
                this.fileList[idx].percentage = parseFloat((p * 100))
              }
              if (this.fileList.every(item => item.percentage === 100)) {
                this.isUpload = true
              }
            })
          } else {
            this.$message.info('暂停上传')
            ele.client.cancleUpload()
          }
          ele.continueUpload = !ele.continueUpload
        }
      })
    },
    submit () {
      this.upload.submit()
    },
    abort () {
      this.upload.abort()
    },
    //处理是否返回文件名
    buildReturnData(){

    },
    onSuccess (res, file) {
      if (this.listType === 'text') {
      if(this.needName){
        if (!this.multiple) {
          this.fileList = []
					this.fileList.push(this.build_file_item(file))
          this.currentValue=file
        }else{
          this.currentValue.push(file)
        }
      }else{
          this.currentValue=res
      }
        this.$emit('input', this.currentValue)
      } else {
        if (!this.multiple) {
          this.fileList = []
          this.fileList.push(this.build_file_item(this.isShowName ? file : file.response))
          this.currentValue = this.isShowName ? file : file.response
        } else {
					this.currentValue=this.currentValue||[]
          this.fileList.push(this.build_file_item(this.isShowName ? file : file.response))
          this.currentValue.push(this.isShowName ? file : file.response)
        }
        this.$emit('input', this.currentValue)
         this.$emit('onSuccess', this.currentValue,file)
      }
    },
    // 导入数据时，如果出错，错误时间处理
    onError (err, file, fileList) {
      let message = err.message
      let errMessage = typeof (err) === 'object' ? JSON.parse(message) : message

      console.log('err+++', errMessage)
      this.$emit('onError', errMessage, file, fileList)
    },
    onRemove (file, fileList) {
      if (!this.multiple) {
        this.currentValue = null
        this.isAdd = true
      } else {
        for (let i = 0; i < this.currentValue.length; i++) {
          let res=this.needName?this.currentValue[i].response:this.currentValue[i]
          if (this.pathUrlName ? this.currentValue[i][this.pathUrlName] === file.path : res === (file.response||file.path)) {
            this.currentValue.splice(i, 1)
            break
          }
        }
      }
      this.$emit('input', this.currentValue)
      this.$emit('onRemove', this.currentValue)
    },
    // 根据相对路径，获得图片的完整路径
    get_image_url (filePath) {
      return (
        this.imgUrl +
                filePath +
                (this.pictureStyle ? this.pictureStyle : '')
      )
    },
    build_file_item (filePath) {
      if (this.isShowName) {
        return {
          url: this.get_image_url(filePath.url),
          path: filePath,
          name: filePath.name
        }
      } else {
        return {
          url: this.get_image_url(filePath),
          path: filePath
        }
      }
    },
    build_file_list (value) {
      let list = []
      if (this.listType === 'text') {
        list = value
        return list
      } else {
        if (value) {
          if ((this.isShowName && !this.multiple) || typeof value === 'string') {
            list.push(this.build_file_item(value))
          } else {
            value.forEach((item, index) => {
              list.push(this.build_file_item(this.pathUrlName ? item && item[this.pathUrlName] : item))
            })
          }
        }
        return list
      }
    },
    handleChange (file, fileList) {
      this.is_change = true
      if (!this.multiple) {
        this.upload.clearFiles()
        this.$nextTick(_ => {
          // 下一帧执行，以便能触发动画
          this.upload && (this.upload.uploadFiles = [file])
        })
      }
    }
  },
  created () {
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.wt-upload-file--no-add{
   .el-upload {
        display: none!important;
    }
}
    .wt-upload-file{
        &--no-add{
        .el-upload--picture-card {
            width: 100%;
            height: 100%;
            border: none;
            img {
                border-radius: 5px;
            }
    }
        }
    }
.bill{
    // ****
    // &__avatar{
    //     &--kkkk{

    //     }
    // }
    // &--active{

    // }
}
</style>
